import Typography from 'common/components/Typography'
import styled from 'styled-components'

const Wrapper = styled.div`
  margin-top: ${(props) =>
    !props.marginTop ? '0' : props.marginTop};
  text-align: center;
`
function StoreDataMessage({
  icon,
  title,
  description,
  marginTop,
}: {
  icon: any
  title: string
  description?: any
  marginTop?: string
}): JSX.Element {
  return (
    <Wrapper marginTop={marginTop}>
      {icon}
      <Typography type="bh2" textAlign="center" marginTop="63px">
        {title}
      </Typography>
      {description && (
        <Typography type="rh4" textAlign="center" marginTop="30px">
          {description}
        </Typography>
      )}
    </Wrapper>
  )
}

export default StoreDataMessage
